import { N76 } from "./TopPrincipals/N76";
import { N76_04 } from "./MonthlySales/N76_04";
import { N76_05 } from "./SalesVSCollection/N76_05";
import { N76_03 } from "./TopCustomerGroups/N76_03";
import { N76_01 } from "./TopItems/N76_01";
import { N76_02 } from "./TopCustomers/N76_02";
export const ExecutiveReports = {
    "sections": [
        N76,
        N76_04,
        N76_05,
        N76_03,
        N76_02,
        N76_01
    ]
}